<template>
  <span class="text-overflow-clip" :style="{ width: width }">{{ text }}</span>
</template>

<script>
  // import { optimizedEventListener } from '@/utils/optimizedEventListener'

  // const opti = optimizedEventListener()

  export default {
    name: 'TextOverflowClip',
    props: {
      text: String
    },
    data: function () {
      return {
        parentWidth: 0
      }
    },
    computed: {
      width: function () {
        // return `${this.parentWidth}px`
      }
    },
    mounted: function () {
      // this.setWidth()

      // opti.add('resize', () => {
      //   this.setWidth()
      // })
    },
    methods: {
      getParentWidth: function () {
        const $parent = this.$parent.$el
        let width = 0

        if ($parent) {
          width = $parent.clientWidth
        }

        return width
      },
      setParentWidth: function () {
        const width = this.getParentWidth()
        this.parentWidth = width
      },
      setWidth: function () {
        this.setParentWidth()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .text-overflow-clip {
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/js/components/TextOverflowClip.vue